import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

export const StyledStack = styled(Stack)({
  width: '100%'
});



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpDeleteDialog/styles.js